<template>
  <div class="AdditionalGoals AllGoals">
    <div id="form-div">
      <div class="row justify-content-left align-items-left">
        <div class="col-md-12">
          <MDBAccordion v-model="activeGoalItem" borderless>
            <div v-for="(goal) in goals" :key="goal.id">
              <div v-if="goal.id === currentGoalId" class="offset-1 col-md-10">
                <div>
                  <img
                      :src="'/images/E-WEB-Goal-' + String(currentGoalId).padStart(2, '0') + '.png'"
                      style="height:100px; width:auto;"
                  />
                  <br /><br />
                  <strong>{{ $t('wheelAnalysis.additionalGoals.targetsLabel') }}</strong>
                  <br />

                  <!-- Use goalIdx derived from goal.id to avoid mismatch with array index -->
                  <div v-for="(target, targetIndex) in goal.targets" :key="target.id">
                    <MDBCheckbox
                        :disabled="!editMode"
                        :id="target.id"
                        :label="target.id + ': ' + target.name"
                        size="small"
                        :model-value="Boolean(selectedTargets?.[Number(goal.id) - 1]?.[targetIndex])"
                        @update:model-value="val => setSafeTarget(Number(goal.id) - 1, targetIndex, val)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </MDBAccordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./_AllGoals.js" lang="js"></script>
<style src="./_AllGoals.less" lang="less"></style>
